import { z } from 'zod'
import { zId, zIdNullable, zIsoDate } from '../common'

// The admin that performed the action. `null` when the account was deleted.
export const zAuditLogActor = z
  .object({
    id: zId,
    email: z.string(),
  })
  .passthrough()
export type AuditLogActor = z.infer<typeof zAuditLogActor>

// Read-only audit journal entry, returned reverse-chronologically. `metadata`
// holds the created state or the applied diff; secrets are already replaced by
// the literal string "[FILTERED]" server-side (expected, not a display bug).
export const zAuditLog = z
  .object({
    id: zId,
    action: z.string(),
    resourceType: z.string(),
    resourceId: zIdNullable,
    adminUser: zAuditLogActor.nullable(),
    metadata: z.record(z.unknown()).nullable(),
    createdAt: zIsoDate,
  })
  .passthrough()
export type AuditLog = z.infer<typeof zAuditLog>
